/* The West Edit: motion layer.
   - Sections and product cards ease in as they scroll into view
   - Info pages highlight the section you are reading
   - The hero drifts gently as you scroll past it
   Everything is visible without this script, and it switches off for reduced motion. */
(function () {
  /* ---- Mobile menu: wordmark at the top, try-on + contact details at the bottom ---- */
  var dressDrawer = function () {
    var t = document.getElementById('we-drawer-extra');
    if (!t) return;
    document.querySelectorAll('.menu-drawer').forEach(function (d) {
      if (d.querySelector('.we-drawer-foot')) return;
      var frag = t.content.cloneNode(true);
      var brand = frag.querySelector('.we-drawer-brand');
      var foot = frag.querySelector('.we-drawer-foot');
      var nav = d.querySelector('.menu-drawer__navigation');
      if (brand && nav) d.insertBefore(brand, nav);
      if (foot) d.appendChild(foot);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dressDrawer);
  else dressDrawer();
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.header__icon--menu')) dressDrawer();
  }, true);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || document.documentElement.classList.contains('shopify-design-mode')) return;

  /* ---- Reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    var root = document.documentElement;
    root.classList.add('we-js');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    var SEL = '.product-grid__item, .resource-list__item, .we-steps__head, .we-occasions__head, .we-pg__sec, .we-pg-cta, .we-reveal';
    // Only new elements are touched, so filtering and sorting stay light
    var watch = function () {
      document.querySelectorAll(SEL).forEach(function (el) {
        if (el.__weSeen) return;
        el.__weSeen = true;
        el.classList.add('we-reveal');
        var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--we-delay', (i % 4) * 70 + 'ms');
        io.observe(el);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    // Filtering / sorting swaps the product grid, so catch new cards too
    var queued = false;
    new MutationObserver(function (records) {
      if (queued) return;
      for (var r = 0; r < records.length; r++) {
        if (records[r].addedNodes.length) {
          queued = true;
          setTimeout(function () { queued = false; watch(); }, 120);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('beforeprint', function () {
      document.querySelectorAll('.we-reveal').forEach(function (el) { el.classList.add('is-in'); });
    });
  }

  /* ---- Info pages: highlight the section you're reading ---- */
  var navLinks = document.querySelectorAll('[data-we-nav]');
  if (navLinks.length && 'IntersectionObserver' in window) {
    var byId = {};
    navLinks.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    var navIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var link = byId[entry.target.id];
        if (!link || link === current) return;
        if (current) current.classList.remove('is-current');
        link.classList.add('is-current');
        current = link;
        var list = link.closest('ul');
        if (list) list.scrollTo({ left: link.parentElement.offsetLeft - 16, behavior: 'smooth' });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    Object.keys(byId).forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec) navIo.observe(sec);
    });
  }

  /* ---- Pause the drifting glows when they are off screen ---- */
  if ('IntersectionObserver' in window) {
    var glowIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('we-paused', !e.isIntersecting); });
    });
    document.querySelectorAll('.we-hero__aura, .we-veil__aura').forEach(function (el) { glowIo.observe(el); });
  }

  /* ---- Hero drift ---- */
  var hero = document.querySelector('[data-we-hero]');
  if (hero) {
    var copy = hero.querySelector('[data-we-hero-copy]');
    var bg = hero.querySelector('[data-we-hero-bg]');
    var ticking = false;
    var update = function () {
      ticking = false;
      var h = hero.offsetHeight || 1;
      var y = Math.min(scroller && scroller.scrollTop ? scroller.scrollTop : window.scrollY, h);
      if (copy) {
        copy.style.transform = 'translate3d(0,' + (y * 0.28).toFixed(1) + 'px,0)';
        copy.style.opacity = String(Math.max(0, 1 - y / (h * 0.75)).toFixed(3));
      }
      if (bg) bg.style.transform = 'translate3d(0,' + (y * 0.12).toFixed(1) + 'px,0)';
    };
    // Horizon scrolls inside .page-wrapper rather than the window, so listen to both
    var scroller = document.querySelector('.page-wrapper');
    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  }
})();
